<template>
  <div class='EnbProduto02'
  :style="{
    backgroundColor: Prefes.produto.corBackground,
    color: Prefes.produto.corFont,
    fontFamily: Prefes.produto.font,
    fontStyle: parseInt(Prefes.produto.fontStyle) ? 'italic' : '',
    fontWeight: parseInt(Prefes.produto.fontBold) ? 'bold' : '',
    textDecoration: parseInt(Prefes.produto.textDecoration) ? 'underline' : '',
    fontSize: Prefes.produto.fontHeight + 'px'
  }"
  >
    <prod-img02
    :data="data"
    />
    <prod-name02
    :data="data.name"
    />
    <div class="valor-btn">
      <prod-valor02 :data="data"/>
      <prod-btn02 @click="Push" :count="false"/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ProdImg02 from './ProdImg02'
import ProdName02 from './ProdName02'
import ProdValor02 from './ProdValor02'
import ProdBtn02 from './ProdBtn02'
export default {
  name: 'EnbProduto02',
  components: { ProdImg02, ProdName02, ProdValor02, ProdBtn02 },
  props: ['data'],
  computed: {
    ...mapGetters(['Prefes'])
  },
  methods: {
    ...mapActions(['SetModal01', 'SetItem01', 'PushCheckout01', 'ToggleCheckout01']),
    Push () {
      if(this.data.tipo === 'Variável') {
        this.SetItem01(this.data)
          .then( async () => {
            if(typeof this.$route.params.categ !== 'undefined') {
              this.$router.push(`/loja/${this.$route.params.categ}/${this.data.link}`)
            } else {
              this.$router.push(`/${this.data.link}`)
            }
          })
        return
      }
      this.PushCheckout01({ item: this.data, qtda: 1 })
      this.ToggleCheckout01(true)
    }
  }
}
</script>

<style scoped>
.EnbProduto02 {
  width: 230px;
  height: 300px;
  margin: 1%;
}

.valor-btn {
  width: 95%;
  height: 35px;
  display: flex;
  align-items: center;
  margin: auto;
}

.EnbProduto02:hover {
  box-shadow: 1px 1px 8px 1px #CCCCCC;
}
</style>
